import { useState } from "react";
import apiClient from "../lib/api";

export type Newsletter = { email: string; };

/**
 * Newsletter subscribe hook. Fire-and-forget: marketing CTAs treat any path
 * as success. Switch to surfaced errors only if the FE flow needs to gate
 * something on a successful subscribe.
 */
export default function useNewsletter() {
  const [loading, setLoading] = useState(false);

  const addNewsletter = async (email: string | undefined) => {
    if (!email) return;
    try {
      setLoading(true);
      await apiClient.post("/api/v1/newsletter/subscribe", { email });
    } catch {
      // Silenced per the legacy fire-and-forget contract.
    } finally {
      setLoading(false);
    }
  };

  return { loading, addNewsletter };
}
